import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-ktostamm-kunde-detail-view',
  imports: [],
  templateUrl: './ktostamm-kunde.detail-view.html',
  styleUrls: ['./ktostamm-kunde.detail-view.css'],
})
export class KtostammKundeDetailView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
